import { ASSET_BASE_URL, audioFileTypes, audioMimeTypes, backFileTypes, backMimeTypes, imageFileTypes, imageMimeTypes, videoFileTypes, WIDEO_BRAND } from "src/editor/core/EditorConstants";

export function _isWideoBrand(context: { brandName?: string } | null): boolean {
    const brandName = context?.brandName || WIDEO_BRAND;
    return brandName === WIDEO_BRAND;
}

export function getAssetTypeFromUrl(url?: string, forcedType?: "image"|"video"|"sound"|"background"): "image"|"video"|"sound"|"background"|"unknown" {
    if (forcedType) return forcedType;

    if (!url) return "unknown";
    const ext = url.split('.').pop()?.toLowerCase();
    if (!ext) return "unknown";

    if (["png","jpg","jpeg","gif","webp"].includes(ext)) return "image";
    if (["mp4","mov","avi","mkv"].includes(ext)) return "video";
    if (["mp3","wav","ogg"].includes(ext)) return "sound";

    return "background";
}

export function getExpectedTypeFromAccept(accept: string): string {
    if (accept === imageMimeTypes.concat(imageFileTypes).join()) return "image";
    if (accept === backMimeTypes.concat(backFileTypes).join()) return "background";
    if (accept === videoFileTypes.join()) return "video";
    if (accept === audioMimeTypes.concat(audioFileTypes).join()) return "sound";
    return "unknown";
}

export function buildAssetFromFav(fav: any) {
    const id = fav.assetIDasString || fav.backgroundIDasString || fav.audioIDasString;
    const fallbackUrl = `${ASSET_BASE_URL}/${id}.png`;
    const url = fav.assetUrl || fav.previewUrl || fav.backgroundUrl || fav.audioUrl || fallbackUrl;
    const preview = fav.previewUrl || fav.assetPreviewUrl || fav.backgroundUrl || fav.audioUrl || fallbackUrl;

    const built = {
        id,
        name: id,
        userId: fav.userId,
        url,
        preview,
        duration: 0,
        fullWidthPreview: false,
        wideoId: null,
    };

    return built;
}

export const buildWideoAssetIdSet = (wideos, styles) => {
    const ids = [];
    for (const style of styles) {
        for (const cat of style.categories) {
            for (const obj of cat.objects) {
                ids.push(obj.id);
            }
        }
    }

    for (const w of wideos) {
        for (const a of w.userAssets || []) {
            ids.push(a.id);
        }
    }

    return new Set(ids);
};

export const getOrphanFavorites = (assetFavs, wideoAssetIds, expectedType) => {
    return assetFavs.filter(fav => {
        const id = fav.assetIDasString || fav.backgroundIDasString || fav.audioIDasString;
        const url = fav.assetUrl || fav.previewUrl || fav.backgroundUrl || fav.audioUrl;
        const type = getAssetTypeFromUrl(url, expectedType === "background" ? "background" : undefined);
        const isOrphan = type === expectedType && !wideoAssetIds.has(id);

        return isOrphan;
    });
};
